import React from 'react';
import useTranslationLgs from '@hooks/i18n/useTranslation.tsx';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import Intro from '@app/layout/Intro.tsx';
import ResponsiveLayout from '@app/layout/ResponsiveLayout.tsx';
import Visits from '@app/pages/timeslots/Visits.tsx';
import { PermissionTypesEnum } from '@api/ringil-api.v2.tsx';

interface ComponentProps {
}

const VisitorListPage: React.FC<ComponentProps> = () => {
  const { tr } = useTranslationLgs();

  return (
    <>
      <ResponsiveLayout
        title={tr(`VisitorListPage.title`, `Návštevy`)}
        oneOfPermission={[
          PermissionTypesEnum.PERMISSION_TIMESLOT_VISITORS_READ,
          PermissionTypesEnum.PERMISSION_TIMESLOT_VISITORS_WRITE
        ]}>
        <Visits />
      </ResponsiveLayout>
    </>
  );
};

export default withAuthenticationRequired(VisitorListPage, {
  onRedirecting: () => <Intro />,
});
